import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Experience from "@/pages/Experience";
import About from "@/pages/About";
import EventTypesIndex from "@/pages/EventTypesIndex";
import EventTypeDetail from "@/pages/EventTypeDetail";
import Gallery from "@/pages/Gallery";
import CaseStudiesIndex from "@/pages/CaseStudiesIndex";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import JournalIndex from "@/pages/JournalIndex";
import JournalDetail from "@/pages/JournalDetail";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import { Toaster } from "@/components/ui/sonner";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout, { RequireAdmin } from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Inquiries from "@/pages/admin/Inquiries";
import MediaManager from "@/pages/admin/MediaManager";
import ContentManager from "@/pages/admin/ContentManager";

function PublicSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/about" element={<About />} />
        <Route path="/event-types" element={<EventTypesIndex />} />
        <Route path="/event-types/:slug" element={<EventTypeDetail />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/case-studies" element={<CaseStudiesIndex />} />
        <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
        <Route path="/journal" element={<JournalIndex />} />
        <Route path="/journal/:slug" element={<JournalDetail />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<Book />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
            <Route index element={<Dashboard />} />
            <Route path="inquiries" element={<Inquiries />} />
            <Route path="media" element={<MediaManager />} />
            <Route path="content/:kind" element={<ContentManager />} />
          </Route>
          <Route path="/*" element={<PublicSite />} />
        </Routes>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
